<template>
  <div class="container">
    <el-row :gutter="0" type="flex" justify="center">
      <el-col :xs="24" :sm="20" :md="18">
        <div class="main">
          <div class="title">失物招领详情</div>
          <div class="icon">
            <img
              v-if="false"
              style="width: 100px"
              src="@/assets/images/pilotService/retrieved.png"
            />
            <img
              v-if="true"
              style="width: 100px"
              src="@/assets/images/pilotService/notRetrieved.png"
            />
          </div>
          <div class="content">
            <div class="lost-info">
              <div class="sign"></div>
              <div class="topFont">物品信息</div>
              <div class="info">
                <div>物品名称：{{ formData.goods_name }}</div>
                <div>物品分类：{{ formData.goods_type_name }}</div>
                <div>丢失地点：{{ formData.address }}</div>
                <div>物品描述：{{ formData.remark }}</div>
              </div>
            </div>
            <div class="lost-image">
              <div class="sign"></div>
              <div class="topFont">物品照片</div>
              <div class="image-list" v-if="formData.pic_set.length !== 0">
                <div class="image-one" v-for="item in formData.pic_set">
                  <img class="image" :src="item" />
                </div>
              </div>
              <div v-else>
                <div class="image-center">
                  <el-empty class="image" description="无图片"></el-empty>
                </div>
              </div>
            </div>
            <!-- h5信息页 -->
            <div class="lost-info-h5">
              <div class="sign"></div>
              <div class="topFont">
                物品信息
                <img
                  v-if="formData.had_find === 1"
                  style="width: 60px; margin-left: 15px"
                  src="@/assets/images/pilotService/retrieved.png"
                />
                <img
                  v-if="formData.had_find === 0"
                  style="width: 60px; margin-left: 15px"
                  src="@/assets/images/pilotService/notRetrieved.png"
                />
              </div>
              <div class="info-h5">
                <div>
                  <div>物品名称</div>
                  <div class="wd">{{ formData.goods_name }}</div>
                </div>
                <div>
                  <div>物品分类</div>
                  <div class="wd">{{ formData.goods_type_id }}</div>
                </div>
                <div>
                  <div>丢失地点</div>
                  <div class="wd">{{ formData.address }}</div>
                </div>
                <div>
                  <div>物品描述</div>
                  <div class="wd">
                    {{ formData.remark }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { read } from "@/api/pilotService/lostFound";
export default {
  data() {
    return {
      formData: {},
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      read(this.$route.query)
        .then((res) => {
          this.formData = res.data;
        })
        .catch((err) => {
          ;
        });
    },
  },
};
</script>

<style scoped>
.container {
  background-color: #f9f9f9;
  padding: 20px 0;
}
.main {
  position: relative;
}
.icon {
  position: absolute;
  top: 28px;
  right: 70px;
}
.title {
  /* padding: 2%; */
  margin-bottom: 20px;
  margin-top: 10px;
  font-family: "Arial Negreta", "Arial Normal", Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 24px;
  letter-spacing: normal;
  color: #3b589f;
  text-align: left;
}
.content {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 2%;
}
.sign {
  float: left;
  background-color: #3b589f;
  width: 10px;
  height: 24px;
  margin-right: 15px;
  border-radius: 10px;
}
.topFont {
  font-family: "Arial Negreta", "Arial Normal", Arial;
  font-weight: 700;
  font-style: normal;
  font-size: 18px;
  letter-spacing: normal;
  color: #3b589f;
  text-align: left;
  text-transform: none;
}
.image-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 15px;
}
.image-one {
  width: 14%;
  margin: 1%;
}
.image-center {
  width: 15%;
  margin: 0 auto;
}
.image {
  width: 100%;
  border-radius: 10px;
}
.lost-info {
  /* margin-top: 5%; */
  width: 100%;
  margin-bottom: 40px;
}
.info {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 2px;
}
.info > div {
  font-family: "Arial Normal", Arial;
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  letter-spacing: normal;
  color: rgb(0, 0, 0);
  text-align: left;
  text-transform: none;
  width: 40%;
  /* margin: 2%; */
  margin:25px 25px 0 25px;
}
.lost-info-h5 {
  display: none;
}

@media only screen and (max-width: 768px) {
  .icon {
    display: none;
  }
  .title {
    font-size: 18px;
    text-align: center;
  }
  .topFont {
    font-size: 15px;
    display: flex;
  }
  .sign {
    width: 8px;
    height: 18px;
  }
  .image-one {
    width: 30%;
  }
  .lost-info {
    display: none;
  }
  .lost-info-h5 {
    display: block;
    margin-top: 25px;
  }
  .info-h5 > div {
    display: flex;
    justify-content: space-between;
    text-align: right;
    align-items: center;
    padding: 10px 25px;
    border-bottom: 2px solid rgba(243, 243, 247, 1);
    font-size: 14px;
    color: #9295a1;
  }
  .wd {
    width: 70%;
  }
}
</style>